import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`Joe the Eskimo has lost his home in a bizarre snow storm, can you help Joe get home?`}</p>
    <p>{`Sliding Home is a puzzle-adventure mobile game that gives the player control of Joe the Eskimo who is trying to get back home. The only problem is all the paths have been iced over, and Joe keeps getting stuck without your help. Rocks, Snow Patches, Switches and Traps are stopping Joe, can you use these to your advantage?`}</p>
    <p>{`The game is written in C++ using the`}
      {" "}
      {` `}
      <a href="https://www.madewithmarmalade.com/" target="_blank">{`Marmalade SDK `}</a>
      {`, the source code can be viewed`}
      {" "}
      {` `}
      <a href="https://github.com/simonrose121/slidinghome" target="_blank">{` here `}</a>
      {`.`}</p>
    <p>{`You can download the apk`}
      {" "}
      {` `}
      <a href={"https://drive.google.com/file/d/0B__XFrFz18GzVTl2Z2ZaSTVzaHM/view"} target="\_blank">{`here`}</a>
      {` .`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      